export const PARTIAL_REVIEW_WARNING =
  'La revisión no pudo verificar por completo todos los aspectos del documento.';

const DROP_WARNING_PATTERNS = [
  /proyecci[oó]n para el modelo/i,
  /proyecci[oó]n se compact/i,
  /estado actual de las marcas/i,
  /^cobertura parcial\.?$/i,
  /omiti[oó] autom[aá]ticamente evidencia o hallazgos/i,
  /no identifica de forma [uú]nica el [aá]rea observada/i,
  /una de las anclas ya no est[aá] disponible/i,
  /fragmento jur[ií]dico citado no aparece en el pasaje legal/i,
  /hallazgo reutiliz[oó] autoridades verificadas del marco jur[ií]dico general/i,
  /fragmento citado no pudo vincularse de forma inequ[ií]voca/i,
];

function rewriteKnownWarning(text) {
  if (/extracci[oó]n disponible est[aá] truncada/i.test(text)) {
    return 'El texto disponible del documento está incompleto.';
  }
  if (/enfoque solicitado excede las comprobaciones estructurales/i.test(text)) {
    return 'El enfoque solicitado no pudo revisarse por completo.';
  }
  if (
    /el servidor redujo la cobertura/i.test(text)
    || /umbrales objetivos de cobertura/i.test(text)
    || /se verificaron \d+ de \d+ bloques/i.test(text)
  ) {
    return PARTIAL_REVIEW_WARNING;
  }
  return text;
}

function isDroppedReviewCopy(text) {
  return DROP_WARNING_PATTERNS.some(pattern => pattern.test(text));
}

export function humanizeReviewSummary(summary) {
  const text = String(summary || '')
    .replace(/\s+respaldados por pasajes exactos/gi, '')
    .replace(/\s+respaldado por pasajes exactos/gi, '')
    .replace(/aspectos jur[ií]dicos y documentales/gi, 'aspectos del documento')
    .replace(/\s+/g, ' ')
    .trim();
  if (!text || isDroppedReviewCopy(text)) return '';
  return text;
}

export function humanizeReviewWarning(warning) {
  const text = String(warning || '').trim();
  if (!text || isDroppedReviewCopy(text)) return '';
  return rewriteKnownWarning(text);
}

export function humanizeReviewWarnings(warnings) {
  const seen = new Set();
  const result = [];
  const values = Array.isArray(warnings) ? warnings : [];
  values.forEach((warning) => {
    if (typeof warning !== 'string') return;
    const text = humanizeReviewWarning(warning);
    if (!text || seen.has(text)) return;
    seen.add(text);
    result.push(text);
  });
  return result.slice(0, 20);
}
